<template>
  <div class="block">
    <div
      class="block_btn block"
      v-if="commonUserDataStatus === 'authorized'"
      @click="setCommonUserDataStatus('blocked')"
    >
      <BaseIcon icon="common-block" />{{
        localStorage.translations.pages['setting-users']['dialog-edit-buttons'].zablokirovat
      }}
    </div>
    <div
      class="block_btn unblock"
      v-if="commonUserDataStatus === 'blocked'"
      @click="setCommonUserDataStatus('authorized')"
    >
      <BaseIcon icon="common-unblock" />{{
        localStorage.translations.pages['setting-users']['dialog-edit-buttons'].razblokirovat
      }}
    </div>
    <div class="block_btn block" v-if="commonUserDataStatus === 'invited'" disabled>
      <BaseIcon icon="common-block" />{{
        localStorage.translations.pages['setting-users']['dialog-edit-buttons'].not_available
      }}
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'BlockUnblock',
  methods: {
    ...mapMutations('commonUser', ['setCommonUserDataStatus']),
  },
  computed: {
    ...mapGetters('commonUser', ['commonUserDataStatus']),
  },
}
</script>

<style lang="scss" scoped>
.block {
  &_btn {
    cursor: pointer;
    user-select: none;
    display: grid;
    justify-content: start;
    grid-template-columns: 14px auto;
    grid-column-gap: 15px;
    align-items: center;
    font-weight: normal;
    font-size: 18px;
    &.block {
      color: #ec1b0e;
    }
    &.unblock {
      color: #26bc2c;
    }
  }
}
</style>
